import * as basicScroll from 'basicscroll';
const parallaxSection = document.querySelectorAll('.parallax-section');

const parallax = () => {
    if (parallaxSection.length) {
        parallaxSection.forEach(section => {
            const instance = basicScroll.create({
                elem: section,
                direct: section,
                from: 'top-bottom',
                to: 'bottom-top',
                props: {
                    '--BGtranslateY': {
                        from: '0',
                        to: '100'
                    }
                },
            });

            instance.start();
        });
    }
};

export default parallax;
